// Guarded so the ajax popup bundle (which runs again on every popup open)
// does not register a second phoenix.link.click listener and double the confirms.
if (!window.__phoenixHtmlLoaded) {
  window.__phoenixHtmlLoaded = true;
  import("phoenix_html");
}
import tippy from "tippy.js";
import "./select2.js";
import Inputmask from "inputmask";
import "tablednd";
import { Autoplay, Carousel } from "@fancyapps/ui/dist/carousel.autoplay.esm";
// Phoenix live view start
import "mdn-polyfills/Object.assign";
import "mdn-polyfills/CustomEvent";
import "mdn-polyfills/String.prototype.startsWith";
import "mdn-polyfills/Array.from";
import "mdn-polyfills/Array.prototype.find";
import "mdn-polyfills/Array.prototype.some";
import "mdn-polyfills/NodeList.prototype.forEach";
import "mdn-polyfills/Element.prototype.closest";
import "mdn-polyfills/Element.prototype.matches";
import "mdn-polyfills/Node.prototype.remove";
import "child-replace-with-polyfill";
import "url-search-params-polyfill";
import "formdata-polyfill";
import "classlist-polyfill";
import "new-event-polyfill";
import "@webcomponents/template";
import "shim-keyboard-event-key";
import "core-js/features/set";
import "core-js/features/url";
import { Socket } from "phoenix";
import { LiveSocket } from "phoenix_live_view";
// Phoenix live view end
import topbar from "topbar";
import Swiper, { Navigation, Pagination, FreeMode } from "swiper";
import Quill from "quill";
import { Fancybox } from "@fancyapps/ui";

console.log('App.js loaded');

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})

function format(address) {
  if (address.text === undefined || address.text === '') {
    return address.street_address_unit;
  } else {
    return address.text;
  }
}

function formatSelection(address) {
  if (address.text === undefined || address.text === '') {
    return address.street_address_unit;
  } else {
    return address.text;
  }
}

function mountSelectAddress() {
  $(document).ready(function () {
    let community_id = document
      .querySelector("input[id='select2_select_address_community_id']")
      .getAttribute("value");

    let tags = document
      .querySelector("input[id='select2_select_address_tags']")
      .getAttribute("value");

    let api_url = document
      .querySelector("input[id='select2_select_address_api_url']")
      .getAttribute("value");

    let limit = document
      .querySelector("input[id='select2_select_address_limit']")
      .getAttribute("value");

    let host = window.location.protocol + "//" + window.location.host;
    let url = new URL(api_url, host);

    if (community_id != null) {
      url.search = new URLSearchParams({ 'community_id': community_id });
    }

    var searchConfig = {
      tags: (tags == "true"),
      ajax: {
        url: url,
        delay: 1000,
        dataType: "json",
        data: function (params) {
          return {
            search_address: params.term,
            limit: limit,
            page: params.page,
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;

          return {
            results: data.rows,
            pagination: {
              more: params.page * 30 < data.rows.length,
            },
          };
        },
      },
      minimumInputLength: 2,
      templateResult: format,
      templateSelection: formatSelection
    };

    $("#pw-select2-address").select2(
      Object.assign(searchConfig, {
        dropdownParent: $(".select-parent")
      })
    )

    $("#pw-select2-address").on("select2:open", function (event) {
      $(document).ready(function () {
        $(".select2-search__field").attr("name", "select2-address-search__field");
      })
    });
  });
}

function mountStandAloneSelectAddress() {
  $(document).ready(function () {
    let tags = document
      .querySelector("input[id='select2_select_address_tags']")
      .getAttribute("value");

    var searchConfig = {
      tags: (tags == "true"),
      templateResult: format,
      templateSelection: formatSelection,
      placeholder: 'Select an address',
      minimumInputLength: 2
    };

    $("#pw-select2-address-stand-alone").select2(
      Object.assign(searchConfig, {
        dropdownParent: $(".select-parent")
      })
    )

    $("#pw-select2-address-stand-alone").on("select2:open", function (event) {
      $(document).ready(function () {
        $(".select2-search__field").attr("name", "select2-address-search__field");
      })
    });
  });
}

// Carousel.Plugins.Autoplay = Autoplay;
let Hooks = {};

Hooks.selectAddress = {
  mounted() {
    mountStandAloneSelectAddress();

    var liveView = this;

    $("#pw-select2-address-stand-alone").on('select2:select', function (e) {
      if (e.params.data.text != null) {
        var data = e.params.data.text;
        liveView.pushEvent("handle_address_input", { 'address': { 'street_address': data } })
      }

      if (e.params.data.street_address != null) {
        var data = e.params.data.street_address;
        liveView.pushEvent("handle_address_input", { 'address': { 'street_address': data } })
      }

      if (e.params.data.street_address != null && e.params.data.unit != null) {
        var data = e.params.data.street_address + ', Unit ' + e.params.data.unit;
        liveView.pushEvent("handle_address_input", { 'address': { 'street_address': data } })
      }
    });
  },
  updated() {
    mountStandAloneSelectAddress();
  }
};

Hooks.noBlurOnMouseEnter = {
  mounted() {
    this.el.addEventListener("mouseenter", (e) => {
      this.pushEvent("disallow_blur", {});
    });
    this.el.addEventListener("mouseleave", (e) => {
      this.pushEvent("allow_blur", {});
    });
  },
};

Hooks.MobileAppDeepLink = {
  mounted() {
    this.handleEvent("redirect", ({ url }) => {
      window.location = url;
    })
  }
}

Hooks.TelephoneInputMask = {
  mounted() {
    this.applyMask();
  },
  updated() {
    this.applyMask();
  },
  applyMask() {
    this.el.querySelectorAll('input[type="tel"]').forEach(input => {
      const im = new Inputmask("(999) 999-9999");
      im.mask(input);
    });
  }
};

function pushPhxEvent(hook, event_text, payload) {
  hook.pushEvent(event_text, payload, (reply, ref) => {
    console.log(reply);
  });
}
Hooks.ItemQuantityChangeHook = {
  mounted() {
    const input = document.getElementById(this.el.id);
    input.addEventListener("blur", (event) => {
      let event_option_id = input.getAttribute("phx-value-event_option_id");
      let event_item_title = input.getAttribute(
        "phx-value-event_attendee_item_title"
      );
      let previousValue = input.getAttribute("phx-value-current_count");
      let quantity = event.target.value;
      let difference = quantity - previousValue;
      let steps = Math.abs(difference);
      if (difference > 0) {
        for (let i = 0; i < steps; i++) {
          pushPhxEvent(this, "add_event_attendee_item", {
            event_attendee_item_title: event_item_title,
            event_option_id: event_option_id,
          });
        }
      } else {
        for (let i = 0; i < steps; i++) {
          pushPhxEvent(this, "remove_event_attendee_item", {
            event_attendee_item_title: event_item_title,
            event_option_id: event_option_id,
          });
        }
      }
    });
  },
};

function initializeCarousel() {
  new Carousel(document.querySelector(".event_live_carousel"), {
    center: true,
    slidesPerPage: 1,
  });
}
Hooks.EventLiveCarousel = {
  mounted() {
    initializeCarousel();
  },
};

import { createHook, mountOnPage } from "./stripe_express_checkout";
import {
  createHook as createStripeBankAccountSetupHook,
  mountOnPage as mountStripeBankAccountSetupOnPage,
} from "./stripe_bank_account_setup";
Hooks.StripeExpressCheckout = createHook();
Hooks.StripeBankAccountSetup = createStripeBankAccountSetupHook();
mountOnPage();
mountStripeBankAccountSetupOnPage();

let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");

let liveSocket = new LiveSocket("/live", Socket, {
  hooks: Hooks,
  params: {
    _csrf_token: csrfToken,
  },
});
// Show progress bar on live navigation and form submits
topbar.config({
  barColors: {
    0: "#29d",
  },
  shadowColor: "rgba(0, 0, 0, .3)",
});
window.addEventListener("phx:page-loading-start", (info) => topbar.show());
window.addEventListener("phx:page-loading-stop", (info) => topbar.hide());
liveSocket.connect();

window.App = {
  mountSelectAddress: function () {
    mountSelectAddress()
  },
  updateSelectStyle: function (selectElement) {
    if (selectElement.value) {
      selectElement.classList.remove("text-muted");
    } else {
      selectElement.classList.add("text-muted");
    }
  },
  toggleForm: function (clickedElement) {
    var bankAccountLabel = document.getElementById("bank-account-label");
    var bankAccountForm = document.getElementById("bank-account-form");
    var creditCardLabel = document.getElementById("credit-card-label");
    var creditCardForm = document.getElementById("credit-card-form");
    if (clickedElement.id == "bank-account-label") {
      creditCardLabel.classList.remove("filled");
      creditCardForm.classList.add("hidden");
      bankAccountLabel.classList.add("filled");
      bankAccountForm.classList.remove("hidden");
    }
    if (clickedElement.id == "credit-card-label") {
      bankAccountLabel.classList.remove("filled");
      bankAccountForm.classList.add("hidden");
      creditCardLabel.classList.add("filled");
      creditCardForm.classList.remove("hidden");
      if ($(".account-payment-method #credit-card-form").length) {
        toggleFormSubmit($(".account-payment-method #credit-card-form"));
      }
    }
  },
  formatPrice: function (input) {
    var value = input.value.split(".").join("");
    if (value.length > 3) {
      value =
        value.substring(0, value.length - 2) +
        "." +
        value.substring(value.length - 2, value.length);
    }
    input.value = value;
  },
  updateSubcommunityOptions: function (input, source) {
    if (input.value == "") {
      var subcommunitySelect = document.getElementById(
        source + "_subcommunity_id"
      );
      for (var i = subcommunitySelect.options.length - 1; i >= 0; i--) {
        subcommunitySelect.remove(i);
      }
    } else {
      $.ajax({
        url: "/admin/api/subcommunities?community_id=" + input.value,
        type: "GET",
        success: function (response) {
          var subcommunitySelect = document.getElementById(
            source + "_subcommunity_id"
          );
          for (var i = subcommunitySelect.options.length - 1; i >= 0; i--) {
            subcommunitySelect.remove(i);
          }
          var option = document.createElement("option");
          option.value = "";
          option.innerHTML = "Select subcommunity";
          subcommunitySelect.appendChild(option);
          for (var i = 0; i < response.length; i++) {
            var option = document.createElement("option");
            option.value = response[i]["id"];
            option.innerHTML = response[i]["name"];
            subcommunitySelect.appendChild(option);
          }
        },
      });
    }
  },
  changeCommunityScheduleOpt: function (elem) {
    var textInput = document.getElementById(elem.id + "_text");
    var community_type = document.getElementById("community_type").value;
    if (elem.value === "Other") {
      textInput.classList.add("form-control");
      textInput.style.display = "block";
      textInput.style.marginTop = ".5em";
      textInput.focus();
      if (community_type == "pin") {
        textInput.setAttribute("required", "");
      }
    } else {
      textInput.removeAttribute("required", "");
      textInput.style.display = "none";
      textInput.classList.remove("form-control");
    }
  },
  onChangeCommunityType: function (type) {
    communityTypeActions(type);
  },
  onChangeEventType: function (sign_up) {
    eventTypeActions(sign_up);
  },
  onChangeCallReason: function (value) {
    callReasonActions(value);
  },
  onChangeEventAttendeeItemStatusOption: function (value) {
    const itemStatusSelects =
      document.getElementsByClassName("pw-individual-item");
    for (const element of itemStatusSelects) {
      element.value = value;
    }
  },
  onCommunityAccessTypeChange: function (event) {
    const accessCodeContainer = document.getElementById(
      "cat_text_container"
    );
    const accessCodeInput = document.getElementById(
      "community_access_code_text_input"
    );
    switch (event.value) {
      case "gate_code_required":
      case "other":
        accessCodeContainer.style.display = "block";
        accessCodeInput.required = true;
        break;
      default:
        accessCodeContainer.style.display = "none";
        accessCodeInput.value = "";
        accessCodeInput.required = false;
        break;
    }
  },
  populateSelectedFilesList: function (event) {
    if (!event.target.files) return;

    const files = event.target.files;
    const containerId = event.target.container_id;

    App.renderFilesToContainer(files, containerId);
  },
  renderFilesToContainer: function (files, containerId) {
    let container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = files.length > 0 ? "" : "No files have been attached.";

    for (let i = 0; i < files.length; i++) {
      let f = files[i];
      let html = `
    <li class="d-flex mb-4 pb-1">
      <div class="avatar flex-shrink-0 me-3">
          <span class="avatar-initial rounded bg-label-primary"><i class="bx bx-file-blank"></i></span>
      </div>
      <div class="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
          <div class="me-2">
            <h6 class="mb-0 pw-file-item">
                <a href="#">${f.name}</a>
            </h6>
          </div>
      </div>
    </li>
    `;
      container.innerHTML += html;
    }
  }
};
$(document).ready(function () {
  function toggleCommunityAccessControlVisibility(checked, selectContainer, selectInput, codeContainer, accessCodeInput) {
    console.log(checked)
    console.log(selectContainer)
    console.log(accessCodeInput)
    if (checked) {
      selectContainer.style.display = "block";
      selectInput.required = true;
    } else {
      selectContainer.style.display = "none";
      selectInput.required = false;
      selectInput.value = "";
      codeContainer.style.display = "none";
      accessCodeInput.value = "";
      accessCodeInput.required = false;
    }
  }
  /* Show/hide community access free-text entry */
  const checkbox = document.getElementById("community_access_code_cb");
  const selectContainer = document.getElementById(
    "cat_select_container"
  );
  const selectInput = document.getElementById("community_access_code_type_input");
  const catTextContainer = document.getElementById(
    "cat_text_container"
  );
  const accessCodeInput = document.getElementById(
    "community_access_code_text_input"
  );
  if (accessCodeInput && accessCodeInput.value) {
    catTextContainer.style.display = "block";
  }
  if (checkbox) {
    toggleCommunityAccessControlVisibility(
      checkbox.checked,
      selectContainer,
      selectInput,
      catTextContainer,
      accessCodeInput
    );
    checkbox.addEventListener("change", (event) => {
      toggleCommunityAccessControlVisibility(
        event.currentTarget.checked,
        selectContainer,
        selectInput,
        catTextContainer,
        accessCodeInput
      );
    });
  }
  /* Hide actions form if user click in other place in screen*/
  $(document).on("click", function (e) {
    var dropdownClasses = [
      "pw-dropdown",
      "pw-dropdown_content",
      "pw-dropdown_label",
      "fa",
    ];
    if (!dropdownClasses.includes(e.target.className)) {
      var dropdowns = document.querySelectorAll(".pw-dropdown_content");
      var fas = document.querySelectorAll(".fa");
      dropdowns.forEach(function (item) {
        item.classList.remove("--open");
      });
      fas.forEach(function (item) {
        item.classList.remove("fas");
        item.classList.remove("fa-times");
      });
    }
  });
  /* Bank Account Form Validation */
  if ($(".account-payment-method #bank-account-form").length) {
    var bankAccountForm = $(".account-payment-method #bank-account-form");
    bankAccountForm.validate({
      errorPlacement: function (error, element) {
        switch (element.attr("name")) {
          case "bank_account_form[autopay]":
            element
              .closest(".check")
              .siblings(".form-field-error")
              .append(error);
            break;
          default:
            element.siblings(".form-field-error").append(error);
        }
      },
      onkeyup: function () {
        toggleFormSubmit(bankAccountForm);
      },
      onclick: function () {
        toggleFormSubmit(bankAccountForm);
      },
      onfocusout: function () {
        toggleFormSubmit(bankAccountForm);
      },
    });
    bankAccountForm.find(".autopay .more-action").click(function () {
      $(this).siblings(".more-text").removeClass("hidden");
      $(this).remove();
    });
    bankAccountForm.find("input").change(toggleFormSubmit(bankAccountForm));
    toggleFormSubmit(bankAccountForm);
  }
  tippy(".pw-step", {
    theme: "light",
  });
  $(".bank-account-forms input.service_address").click(function (event) {
    if (this.checked) {
      $(".bank-account-forms .billing_form .inputs")
        .children("input, select")
        .attr("disabled", "disabled")
        .addClass("disabled");
    } else {
      $(".bank-account-forms .billing_form .inputs")
        .children("input, select")
        .removeAttr("disabled")
        .removeClass("disabled");
    }
  });
  $(".credit-card-forms input.service_address").click(function (event) {
    if (this.checked) {
      $(".credit-card-forms .billing_form .inputs")
        .children("input, select")
        .attr("disabled", "disabled")
        .addClass("disabled");
    } else {
      $(".credit-card-forms .billing_form .inputs")
        .children("input, select")
        .removeAttr("disabled")
        .removeClass("disabled");
    }
  });
  /* Admin User Address autocomplete */
  if ($("#user_address_address_street").length) {
    $("#user_address_address_street")[0].addEventListener(
      "awesomplete-selectcomplete",
      function (event) {
        $("#user_address_id").val(event.text.value);
        $("#user_address_address_street").val(event.text.label);
      }
    );
  }
  if ($("#address_user_id").length) {
    $("#address_user_id")[0].addEventListener(
      "awesomplete-selectcomplete",
      function (event) {
        $("#address_new_user_id").val(event.text.value);
        $("#address_user_id").val(event.text.label);
      }
    );
  }
  /* Credit Card Form Validation */
  if ($(".account-payment-method #credit-card-form").length) {
    var creditCardForm = $(".account-payment-method #credit-card-form");
    creditCardForm.validate({
      errorPlacement: function (error, element) {
        switch (element.attr("name")) {
          case "credit_card_form[autopay]":
            element
              .closest(".check")
              .siblings(".form-field-error")
              .append(error);
            break;
          default:
            element.siblings(".form-field-error").append(error);
        }
      },
      onkeyup: function () {
        toggleFormSubmit(creditCardForm);
      },
      onclick: function () {
        toggleFormSubmit(creditCardForm);
      },
      onfocusout: function () {
        toggleFormSubmit(creditCardForm);
      },
    });
    creditCardForm.find(".autopay .more-action").click(function () {
      $(this).siblings(".more-text").removeClass("hidden");
      $(this).remove();
    });
    creditCardForm.find("input").change(toggleFormSubmit(creditCardForm));
    toggleFormSubmit(creditCardForm);
  }
  /* Subcommunity Individual Services Form */
  // on select change
  $(document).on(
    "change",
    ".subcommunity-individual-services-form .individual_service_types select",
    function () {
      onChangeServiceType($(this));
    }
  );
  $(document).on("click", function (e) {
    var container = $(".action-dropdown");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".dropdown-content").css("display", "none");
    }
  });
  $(".action-dropdown").on("click", function (e) {
    let target = $(e.target).parent().children(".dropdown-content");
    if (target.css("display") == "none") {
      target.css("display", "inherit");
    } else {
      target.css("display", "none");
    }
  });
  // on page load
  onChangeServiceType(
    $(".subcommunity-individual-services-form .individual_service_types select")
  );
  /* Subcommunity Individual Services Form */
  // on select change
  $(document).on(
    "change",
    ".community-individual-services-form .individual_service_types select",
    function () {
      onChangeServiceType($(this));
    }
  );
  // on page load
  onChangeServiceType(
    $(".community-individual-services-form .individual_service_types select")
  );

  function onChangeServiceType(type) {
    if (type.val() === "one_time") {
      type
        .closest(".form-field")
        .siblings(".form-field.day_of_the_week")
        .hide();
      type.closest(".form-field").siblings(".form-field.frequency").hide();
      type.closest(".form-field").siblings(".form-field.date").show();
    } else {
      type
        .closest(".form-field")
        .siblings(".form-field.day_of_the_week")
        .show();
      type.closest(".form-field").siblings(".form-field.frequency").show();
      type.closest(".form-field").siblings(".form-field.date").hide();
    }
  }
  if (document.getElementById("menuTriggerButton")) {
    document
      .getElementById("menuTriggerButton")
      .addEventListener("click", function (clickedElement) {
        var navbar = document.querySelector(".pw-main-admin-nav");
        var menuButton = document.getElementById("menuTriggerButton");
        var currentImgSourceArray = menuButton.children[0].src.split("/");
        var currentImageSource =
          currentImgSourceArray[currentImgSourceArray.length - 1];
        if (currentImageSource === "x.svg") {
          currentImgSourceArray[currentImgSourceArray.length - 1] = "menu.svg";
          menuButton.children[0].src = currentImgSourceArray.join("/");
          navbar.classList.remove("--active-menu");
        } else {
          currentImgSourceArray[currentImgSourceArray.length - 1] = "x.svg";
          menuButton.children[0].src = currentImgSourceArray.join("/");
          navbar.classList.add("--active-menu");
        }
      });
  }

  function formatDateTimeInputs() {
    var dateTimeMask = new Inputmask({
      onBeforeMask: function (pastedValue, opts) {
        if (!!pastedValue) {
          let a = pastedValue.split("-");
          pastedValue = a[0] + "-" + a[1] + "-" + a[2];
        }
        return pastedValue;
      },
    });
    document.querySelectorAll('[type="tel"]').forEach(function (item) {
      var im = new Inputmask("(999) 999-9999");
      im.mask(item);
    });
    document.querySelectorAll('[type="date"]').forEach(function (item) {
      // item.setAttribute('type', 'text');
      item.dataset.inputmaskAlias = "date";
      item.dataset.inputmaskInputformat = "yyyy-mm-dd";
      // item.dataset.inputmaskInputformat = 'mm/dd/yyyy';
      item.setAttribute("inputmode", "numeric");
      dateTimeMask.mask(item);
    });
    document.querySelectorAll('[type="time"]').forEach(function (item) {
      // item.setAttribute('type', 'text');
      item.dataset.inputmaskAlias = "datetime";
      item.dataset.inputmaskInputformat = "hh:mm";
      item.setAttribute("inputmode", "numeric");
      dateTimeMask.mask(item);
    });
  }
  formatDateTimeInputs();
  Fancybox.bind("[data-fancybox]", {
    dragToClose: false,
    afterShow: function (instance, slide) {
      formatDateTimeInputs();
    },
  });
  tryToOpenPopup("event");
  let billing_state_select = document.getElementById("billing_state_select");
  let ticket_reason_select = document.getElementById("ticket_reason_select");
  if (billing_state_select) {
    App.updateSelectStyle(billing_state_select);
  }
  if (ticket_reason_select) {
    App.updateSelectStyle(ticket_reason_select);
  }
  $("#offer-items-table").tableDnD({
    onDrop: function (table, row) {
      var tablePositions = [];
      $('#offer-items-table tbody tr').each(function (index) {
        var id_and_group = this.id.split("|");
        tablePositions.push({
          old_position: parseInt(id_and_group[0]),
          new_position: index + 1,
          group_id: id_and_group[1]
        });
      });
      // Update the hidden input's value with the serialized tablePositions array
      $('#table-positions-input').val(JSON.stringify(tablePositions));
    }
  });
});

function tryToOpenPopup(entity) {
  let searchParams = new URLSearchParams(window.location.search);
  let paramName = `popup_${entity}_id`;
  const url = new URL(location);
  url.searchParams.delete(paramName);
  history.pushState(null, document.title, url);
  if (searchParams.has(paramName)) {
    let param = searchParams.get(paramName);
    let fancybox = Fancybox.show([{
      src: `/events/${param}?view=live`,
      type: "ajax",
      preload: false,
    },]);
  }
}

function eventTypeActions(sign_up) {
  if (sign_up) {
    changeFieldRequired("event_must_sign_up_before", true);
    changeLabelRequired("must_sign_up_before_label", true);
  } else {
    changeFieldRequired("event_must_sign_up_before", false);
    changeLabelRequired("must_sign_up_before_label", false);
  }
}

function callReasonActions(value) {
  if (value == "other") {
    changeFieldRequired("call_log_description", true);
    changeLabelRequired("call_log_description_label", true);
  } else {
    changeFieldRequired("call_log_description", false);
    changeLabelRequired("call_log_description_label", false);
  }
}

function communityTypeActions(type) {
  switch (type) {
    case "im":
      let signupFeeField = document.getElementById("signup_fee");

      signupFeeField.disabled = true;
      signupFeeField.value = 0;
      break;

    case "platform_only":
      signupFeeField = document.getElementById("signup_fee");

      signupFeeField.disabled = true;
      signupFeeField.value = 0;
      break;

    case "managed_pin":
      signupFeeField = document.getElementById("signup_fee");
      signupFeeField.disabled = false;
      signupFeeField.value = signupFeeField.defaultValue;

      changeFieldRequired("trash_schedule", false);
      changeFieldRequired("trash_schedule_text", false);
      changeLabelRequired("trash_label", false);
      changeFieldRequired("recycling_schedule", false);
      changeFieldRequired("recycling_schedule_text", false);
      changeLabelRequired("recycling_label", false);
      changeFieldRequired("yard_waste_schedule", false);
      changeFieldRequired("yard_waste_schedule_text", false);
      changeLabelRequired("yard_waste_label", false);
      changeFieldRequired("first_billing_date", false);
      changeLabelRequired("first_billing_date_label", false);
      changeFieldRequired("signup_fee", false);
      changeLabelRequired("signup_fee_label", false);
      break;
    case "pin":
      signupFeeField = document.getElementById("signup_fee");
      signupFeeField.disabled = false;
      signupFeeField.value = signupFeeField.defaultValue;

      changeFieldRequired("trash_schedule", true);
      changeFieldRequired("trash_schedule_text", true);
      changeLabelRequired("trash_label", true);
      changeFieldRequired("recycling_schedule", true);
      changeFieldRequired("recycling_schedule_text", true);
      changeLabelRequired("recycling_label", true);
      changeFieldRequired("yard_waste_schedule", true);
      changeFieldRequired("yard_waste_schedule_text", true);
      changeLabelRequired("yard_waste_label", true);
      changeFieldRequired("first_billing_date", true);
      changeLabelRequired("first_billing_date_label", true);
      changeFieldRequired("signup_fee", true);
      changeLabelRequired("signup_fee_label", true);
      break;

    default:
      signupFeeField = document.getElementById("signup_fee");
      signupFeeField.disabled = false;
      signupFeeField.value = signupFeeField.defaultValue;
  }
}

function changeLabelRequired(label_name, value) {
  var label = document.getElementById(label_name);
  if (value) {
    label.classList.add("--required");
  } else {
    label.classList.remove("--required");
  }
}

function changeFieldRequired(field_name, value) {
  var field = document.getElementById(field_name);
  if (value) {
    field.setAttribute("required", "");
  } else {
    field.removeAttribute("required", "");
  }
}
/* Global Helpers */
function toggleFormSubmit(form) {
  if (form.validate().checkForm()) {
    form
      .find('*[type="submit"]')
      .removeAttr("disabled")
      .removeClass("disabled");
  } else {
    form
      .find('*[type="submit"]')
      .attr("disabled", "disabled")
      .addClass("disabled");
  }
}
/* Disable form submit button after click */
document.querySelectorAll(".disabled-submit").forEach(function (item) {
  item.addEventListener("click", function (e) {
    this.style.pointerEvents = "none";
    this.style.opacity = 0.5;
  });
});
document.querySelectorAll("[required]").forEach(function (item) {
  item.addEventListener("input", function () {
    document.querySelectorAll('[type="submit"]').forEach(function (btn) {
      btn.style.pointerEvents = "auto";
      btn.style.opacity = 1;
    });
  });
});
/* Disable scroll behavior on number inputs */
$("form").on("focus", "input[type=number]", function (e) {
  $(this).on("wheel.disableScroll", function (e) {
    e.preventDefault();
  });
});
$("form").on("blur", "input[type=number]", function (e) {
  $(this).off("wheel.disableScroll");
});
console.log(
  document.querySelector('meta[name="csrf-token"]').getAttribute("content")
);
var swiper = new Swiper(".pw-event-swiper", {
  modules: [Navigation, FreeMode],
  slidesPerView: 1.15,
  spaceBetween: 30,
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
$(".accordion-button").on("click", function (e) {
  $(".accordion-button").each(function (index) {
    let accordionButton = $(this)[0];
    if (accordionButton.classList.contains("collapsed")) {
      accordionButton.classList.remove("pw-accordion-button");
      accordionButton.classList.add("text-muted");
    } else {
      accordionButton.classList.add("pw-accordion-button");
      accordionButton.classList.remove("text-muted");
    }
  });
});

$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})
